export default __webpack_public_path__ + "static/media/CircleArrowRight.f1f6dd77.svg";